// extracted by mini-css-extract-plugin
export default {"content":"section_experience-modules___content___fd2c64b9","editButton":"section_experience-modules___editButton___a7504cb8"};